import React, { Component } from "react";
import { connect } from "react-redux";
import Pagination from "../../paginator2/Paginator";
import Loading from "../../common/Loading";
import { searchPropComRents } from "../../../actions/propertyComAction_Ggn";
import { openModal } from "../../../actions/modalAction";

import { Icon } from "semantic-ui-react";
import PropComSummary from "./PropComSummary";

class PropComRentSearchList extends Component {
  state = {
    pageO: "",
    id: "",
  };
  componentDidMount() {
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };
    const { limitCR, offsetCR } = this.props;

    this.props.searchPropComRents(values, limitCR, offsetCR);
  }
  handleSearchPropComRent = () => {
    this.props.openModal("SearchModal", { propCR_Ggn: true });
  };

  //*******************************************************

  handleRefresh = () => {
    const { offsetCR, limitCR } = this.props;
    const values =
      (this.props.form !== undefined && this.props.form.values) || {};

    this.props.searchPropComRents(values, limitCR, offsetCR);
  };

  //^^^^^^^^^^^^^^^^^^^^^^^^^
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  //###########################################
  back = () => {
    const { limitCR, offsetCR } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };
    if (offsetCR === 0) {
      return;
    }

    this.props.searchPropComRents(values, limitCR, offsetCR - limitCR);
    window.scroll(0, 0);
  };

  advance = () => {
    const { countCR, limitCR, offsetCR } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };
    if (offsetCR + limitCR > countCR) {
      return;
    }

    this.props.searchPropComRents(values, limitCR, offsetCR + limitCR);
    window.scroll(0, 0);
  };
  //***************** */

  handleGoToPage2 = (page) => {
    const { limitCR } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };

    this.props.searchPropComRents(values, limitCR, (page - 1) * limitCR);
    window.scroll(0, 0);
  };

  renderLoading = () => {
    if (this.props.fetchingCR === true) {
      return <Loading />;
    }
  };

  render() {
    return (
      <div className="maindiv-820 ">
        <div className="card-attached" style={{ textAlign: "center" }}>
          {/**/}
          <div className="border-heading color-CornflowerBlue flex-center pxy-10">
            <div style={{ flex: "15%" }} onClick={this.handleSearchPropComRent}>
              <span className="tag-button">
                {" "}
                <Icon name="search" />
              </span>
            </div>

            <div
              style={{ display: "flex", flex: "80%", justifyContent: "center" }}
            >
              <div className="font-20B ml-05 color-head-prop">
                {this.props.countCR} Commercial Property For Rent in{" "}
                {this.props.city}
              </div>
            </div>
          </div>
          {/**/}
        </div>
        {/*  */}

        <div>
          {this.renderLoading()}

          {this.props.propcomsCR.map((item) => (
            <PropComSummary
              handleRefresh={this.handleRefresh}
              key={item._id}
              propcom={item}
            />
          ))}
        </div>

        <div className="card-attached flex-center ">
          {this.props.propcomsCR !== undefined &&
            this.props.propcomsCR.length && (
              <Pagination
                changePage={this.handleGoToPage2}
                advance={this.advance}
                back={this.back}
                page={
                  this.props.offsetCR === 0
                    ? 1
                    : Math.ceil(this.props.offsetCR / this.props.limitCR + 1)
                }
                pages={Math.ceil(this.props.countCR / this.props.limitCR)}
              />
            )}
        </div>

        {/*  */}

        <br />
        <br />
      </div>
    );

    //@@@@@
  }
}

const mapStateToProps = ({ ggn_com_property, auth, form }) => {
  const { city, fetchingCR, limitCR, offsetCR, countCR } = ggn_com_property;

  return {
    city,
    fetchingCR,
    limitCR,
    offsetCR,
    countCR,
    form: form.PropComRentSearch,
    propcomsCR: ggn_com_property.propcomsCR,
    userA: auth.userA,
  };
};

export default connect(mapStateToProps, { searchPropComRents, openModal })(
  PropComRentSearchList
);
